<script setup lang="ts">
import { VSection, VTextField, VToggleButtonField } from '@/modules/shared/components'
import { computed } from 'vue'
import VSelect from './v-select.vue'
import { useAddressStore } from '@/modules/shared/stores/address-store'

const props = defineProps<{
  modelValue?: any
  v$: any
}>()

const emit = defineEmits(['update:modelValue'])

const addressStore = useAddressStore()

const form = computed({
  get: (): any => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const notFilingReasonOptions = ['By others', 'Consolidated', 'DRE', 'Dissolved', 'Uncertain'].map((reason) => ({
  label: reason,
  value: reason,
}))

const basisOptions = ['Accrual', 'Cash', 'Hybrid', 'Other'].map((basis) => ({
  label: basis,
  value: basis,
}))
</script>

<template>
  <VSection class="!mb-0 space-y-6">
    <VToggleButtonField
      v-model="form.is_filing_required"
      label="Does this entity require a tax return?"
      property="is_filing_required"
      :v$="v$"
    />
    <div class="grid gap-4 md:grid-cols-2">
      <VTextField
        v-model="form.starting_tax_year"
        type="number"
        label="Starting Tax Year"
        property="starting_tax_year"
        :v$="v$"
      />
      <VTextField
        v-model="form.ending_tax_year"
        type="number"
        label="Ending Tax Year"
        property="ending_tax_year"
        :v$="v$"
      />
    </div>
    <VSelect
      v-if="!form.is_filing_required"
      v-model="form.not_filing_reason"
      label="Not Filing Reason (select all that apply)"
      :options="notFilingReasonOptions"
      property="not_filing_reason"
      :v$="v$"
    />
    <VTextField v-model="form.gosystem_locator" label="Tax Locator" property="gosystem_locator" :v$="v$" />

    <VSelect v-model="form.basis" label="Tax Basis" :options="basisOptions" property="basis" :v$="v$" />
    <VSelect
      v-model="form.state_filing"
      label="Tax State Filing"
      :options="addressStore.stateOptions"
      property="state_filing"
      :v$="v$"
    />
  </VSection>
</template>
